import React, { useState } from 'react'
import Axios from 'axios';
import Select from 'react-select';
import { getUser } from '../../actions/session';
import { CREATE_CALL_RESTRICTION, GET_ALL_ACCOUNTS, GET_ALL_CARRIER } from '../../config/rest_endpoints'
import { Notifications } from '../common/notification';


const AddRestriction = (props) => {
    // console.log('props :>> ', props);
    const [userInfo] = useState(getUser())

    const [selectedOption, setSelectedOption] = useState([]);
    const [seletedValue, setSeletedValue] = useState('');
    const [contactNumber, setContactNumber] = useState(null);

    // console.log('contactNumber :>> ', contactNumber);


    const [typeOption] = useState([
        { label: 'ANI', value: 'ani' },
        { label: 'DNS', value: 'dnis' },
        { label: 'LRN', value: 'lrn' },
    ])
    const [typeSelect, setTypeSelect] = useState('')

    //  console.log('typeSelect :>> ', typeSelect['value']);
    const [state, setState] = useState({
        note: '',
        prefix: []
    })

    console.log('state :>> ', state.note);

    const [isSubmit, setIsSubmit] = useState(false)
    const [selectDisable, setSelectDisable] = useState(false)

    const clearState = () => {
        setState({
            note: '',
            prefix: []
        })
        setContactNumber("")
        setTypeSelect('')
        setSelectedOption([])
    }

    const handleType = (selectedOption) => {
        setTypeSelect(selectedOption);
        // console.log("Selected Type:", selectedOption);
    };

    // const handleType = (typeSelect) => {
    //     setTypeSelect(typeSelect)
    //     if (typeSelect['value'] === 'All') {
    //         setSelectDisable(true)
    //         setSeletedValue('')
    //     }
    //     else if (typeSelect['value'] === 'Account') {
    //         setSelectDisable(false)
    //         const headers = { "Authorization": "Bearer " + userInfo.token };
    //         Axios.get(`${GET_ALL_ACCOUNTS}`, { headers }).then(res => {
    //             if (res) {
    //                 console.log(`res`, res)
    //                 const resp = res.data.data
    //                 let accRes = resp.map((row) => {
    //                     row['label'] = row['accountName']
    //                     row['value'] = row['id']
    //                     return row
    //                 })
    //                 setSelectedOption(accRes)
    //             }
    //         }).catch(err => {
    //             console.log(`err`, err)
    //         })
    //     }
    //     else {
    //         setSelectDisable(false)
    //         const headers = { "Authorization": "Bearer " + userInfo.token };
    //         Axios.get(`${GET_ALL_CARRIER}`, { headers }).then(res => {
    //             if (res) {
    //                 console.log(`res`, res)
    //                 const resp = res.data.data
    //                 let accRes = resp.map((row) => {
    //                     row['label'] = row['name']
    //                     row['value'] = row['domain']
    //                     return row
    //                 })
    //                 setSelectedOption(accRes)
    //             }
    //         }).catch(err => {
    //             console.log(`err`, err)
    //         })
    //     }
    // }

    const handleSelectedValue = (seletedValue) => {
        setSeletedValue(seletedValue)
        console.log(`selectedValue`, seletedValue)
    }

    const handleState = (e) => {
        const { name, value } = e.target
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const submitRestriction = () => {
        const payload = {
            "numberType": typeSelect['value'],
            "number": contactNumber,
            "description": state.note
        }
        setIsSubmit(true)
        const headers = { "Authorization": "Bearer " + userInfo.token };
        Axios.post(`${CREATE_CALL_RESTRICTION}`, payload, { headers }).then(res => {
            if (res) {
                const { message } = res.data
                setIsSubmit(false)
                props.close()
                props.refreshList()
                clearState()
                Notifications.notify(message, "Created", 'success')
            }
        }).catch(err => {
            const { message } = err.response.data
            Notifications.notify(message, "Failed", "error")
            setIsSubmit(false)
        })
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <label >Type</label>
                    <Select
                        value={typeSelect}
                        onChange={handleType}
                        options={typeOption}
                        placeholder="Select Type"
                    />
                </div>
            </div>

            <div className="col-md-12">
                <div className="form-group">
                    <label>Number</label>
                    <input
                        type="number"
                        className="form-control"
                        value={contactNumber}
                        onChange={(e) => setContactNumber(e.target.value)}
                        placeholder="Enter Contact Number"
                        disabled={selectDisable}
                    />
                </div>
            </div>

            {/* <div className="col-md-6">
                <div className="form-group">
                    <label >Account/Carrier</label>
                    <Select
                        value={seletedValue}
                        onChange={handleSelectedValue}
                        options={selectedOption}
                        placeholder="Select Type"
                        isDisabled={selectDisable ? true :false}
                    />
                </div>
            </div> */}
            {/* <div className="col-md-6">
                <div className="form-group">
                    <label >Prefixes</label>
                    <textarea rows="3" cols="3" class="form-control" name="prefix" value={state.prefix} onChange={handleState} placeholder="Enter newline separated US prefixes eg.. 2123737200"></textarea>
                </div>
            </div> */}
            <div className="col-md-12">
                <div className="form-group">
                    <label>Any Note</label>
                    <textarea rows="3" cols="3" className="form-control" name="note" value={state.note}
                        onChange={handleState} placeholder="Enter note eg.. 911 redirect"></textarea>
                </div>
            </div>
            <div className="col-md-6 ml-auto">
                <button type="submit" class="btn btn-success btn-sm main-button float-right" onClick={submitRestriction} disabled={isSubmit ? true : false}>Create
                    <i className={isSubmit ? "icon-spinner4 spinner ml-2 " : 'icon-paperplane ml-2'}></i>
                </button>
            </div>
        </div>
    )
}

export default AddRestriction